import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IFullStressScoringPayload,
  ActionType,
  IFullStressScoringResponse,
} from "models/stressCheck/fullStressScoringInformation";
import { httpStatus } from "configs/httpStatus";
import { getFullStressScoringInfomation } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./fullStressScoringInfoActions";

function* getFullStressScoringSaga({
  payload,
}: {
  payload: IFullStressScoringPayload;
}) {
  try {
    const response: IFullStressScoringResponse = yield call(
      getFullStressScoringInfomation,
      payload
    );

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetFullStressScoringWatcher() {
  yield takeLatest(
    ActionType.FULL_STRESS_SCORING as any,
    getFullStressScoringSaga
  );
}

export default [fork(onGetFullStressScoringWatcher)];
